import type { ScheduleModeConfig } from '../types';

export const manualModeConfig: ScheduleModeConfig = {
  key: 'manual',
  navigationStyle: 'tabs',
  steps: [
    { key: 'details', label: 'Details' },
    { key: 'communication', label: 'Invites & emails' },
    { key: 'scorecard', label: 'Scorecard' },
  ],
  showSecondaryCta: true,
};
